module.exports = __webpack_public_path__ + "static/cryptoVsWallstreet-2ea62174f7f78ca7403185e09e247a70.png";